import styled from 'styled-components';

export const BarSegmentChartSC = styled.div`
  div.bmi-widget-graph {
    height: 52px;
    margin-bottom: 35px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 16px;

    .indicator-container {
      width: 100%;
      position: relative;
      padding-left: 8px;
      padding-right: 8px;
    }

    &__values {
      display: flex;
      justify-content: center;

      span {
        display: block;
        color: rgba(41, 49, 87, 0.6);
        font-size: 12px;
        letter-spacing: 0;
        line-height: 16px;
        text-align: center;
      }
    }

    div.bmi-widget-graph-line {
      height: 20px;
      border-radius: 13px;
      background-color: rgba(245, 245, 247, 1);
      display: flex;
      padding: 8px;

      > div {
        width: 25%;
        height: 4px;
        border-radius: 2px;
        margin-right: 1px;
      }

      > div:last-child {
        margin-right: 0;
      }

      &__under {
        background-color: rgba(95, 136, 232, 1);
      }

      &__normal {
        background-color: rgba(95, 232, 156, 1);
      }

      &__upper {
        background-color: rgba(229, 189, 106, 1);
      }

      &__overweight {
        background-color: rgba(255, 51, 92, 1);
      }
    }

    .bmi-widget-graph-labels {
      display: flex;

      > span {
        width: 100%;
        display: block;
        color: rgba(41, 49, 87, 0.6);
        font-size: 12px;
        letter-spacing: 0;
        line-height: 16px;
        text-align: center;
      }
    }
  }

  div.bmi-widget-data {
    width: 100%;
    height: 40px;
    max-width: 265px;
    margin: 0 auto 16px auto;
    display: flex;
    justify-content: center;

    > div.bmi-widget-data__item {
      width: 75px;
      font-size: 14px;
      color: rgba(41, 49, 87, 0.6);
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
      text-align: center;

      > span:not(:first-child) {
        font-size: 12px;
      }
    }

    > div.highlight {
      width: 115px;
      color: rgba(95, 232, 156, 1);
      font-size: 20px;
      font-weight: 800;
      letter-spacing: 0;
      line-height: 24px;
    }

    > div.bmi-widget-data__fullwidth {
      width: 100%;
    }

    > div.bmi-widget-data__bmi {
      width: 115px;
      color: rgba(95, 232, 156, 1);
      font-size: 20px;
      font-weight: 800;
      letter-spacing: 0;
      line-height: 24px;

      > span:not(:first-child) {
        font-size: 12px;
      }

      &.blue {
        color: rgba(95, 136, 232, 1);
      }

      &.green {
        color: rgba(95, 232, 156, 1);
      }

      &.yellow {
        color: rgba(229, 189, 106, 1);
      }

      &.red {
        color: rgba(255, 51, 92, 1);
      }

      &.grey {
        color: rgba(41, 49, 87, 0.6);
      }
    }

    > div > span {
      display: block;
      margin: 0 auto;
      text-align: center;
    }
  }
`;
